import { render, staticRenderFns } from "./createDialog.vue?vue&type=template&id=a84e0248&scoped=true&"
import script from "./createDialog.vue?vue&type=script&lang=js&"
export * from "./createDialog.vue?vue&type=script&lang=js&"
import style0 from "./createDialog.vue?vue&type=style&index=0&id=a84e0248&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a84e0248",
  null
  
)

export default component.exports